// extracted by mini-css-extract-plugin
export default {"buttonWithSeparator":"CloseMenuButton__buttonWithSeparator--3lCBt"};